export const Significance = {
  MAJOR: {
    value: 'MAJOR',
    icon: 'fa-circle-exclamation',
    getTooltip: () => 'Major significance; click to change to Minor/Administrative'
  },
  MINOR: {
    value: 'MINOR', 
    icon: 'fa-triangle-exclamation',
    getTooltip: () => 'Minor significance; click to change to Administrative/Major'
  },
  ADMINISTRATIVE: {
    value: 'ADMINISTRATIVE',
    icon: 'fa-circle-info',
    getTooltip: () => 'Administrative significance; click to change to Major/Minor'
  }
};

/**
 * Get the next significance value in the cycle: MAJOR → MINOR → ADMINISTRATIVE → MAJOR
 * @param {string} currentSignificance - Current significance value ('MAJOR', 'MINOR', or 'ADMINISTRATIVE')
 * @returns {string} The next significance value in the cycle
 */
export const getNextSignificance = (currentSignificance) => {
  if (currentSignificance === Significance.MAJOR.value) {
    return Significance.MINOR.value;
  } else if (currentSignificance === Significance.MINOR.value) {
    return Significance.ADMINISTRATIVE.value;
  } else {
    return Significance.MAJOR.value;
  }
};

/**
 * Get the opposite significance value (legacy - kept for backward compatibility)
 * @deprecated Use getNextSignificance for cyclic toggling
 * @param {string} currentSignificance - Current significance value
 * @returns {string} The next significance value
 */
export const getOppositeSignificance = (currentSignificance) => {
  return getNextSignificance(currentSignificance);
};

/**
 * Get significance configuration by value
 * @param {string} significanceValue - Significance value ('MAJOR', 'MINOR', or 'ADMINISTRATIVE')
 * @returns {Object} Significance configuration object
 */
export const getSignificanceConfig = (significanceValue) => {
  if (significanceValue === Significance.MAJOR.value) {
    return Significance.MAJOR;
  } else if (significanceValue === Significance.MINOR.value) {
    return Significance.MINOR;
  } else if (significanceValue === Significance.ADMINISTRATIVE.value) {
    return Significance.ADMINISTRATIVE;
  }
  // Default fallback to MINOR for backwards compatibility
  return Significance.MINOR;
};
